<div class="d-flex justify-content-between">
    <h3 class="text-center font-poppins font-18 mb-4 font-semibold">Book a demo</h3>
    <mat-icon class="cursor-pointer" (click)="close()">close</mat-icon>
</div>
<div id="hubspotFormContainer" class="custom-scroller"></div>